import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Company store for managing multi-company access
 * Tracks which companies the user can access and the currently selected company filter
 */
export const useCompanyStore = create(
  persist(
    (set, get) => ({
      // List of companies the user has access to
      companies: [],

      // Currently selected company ID (null = all companies)
      selectedCompanyId: null,

      // Whether user has access to multiple companies
      hasMultipleCompanies: false,

      // Set companies from API response
      setCompanies: (companies) => set({
        companies,
        hasMultipleCompanies: companies.length > 1
      }),

      // Set selected company filter
      setSelectedCompanyId: (id) => set({ selectedCompanyId: id }),

      // Clear company selection (show all)
      clearSelection: () => set({ selectedCompanyId: null }),

      // Get company name by ID
      getCompanyName: (id) => {
        const company = get().companies.find(c => c.id === id);
        return company?.name || `Company ${id}`;
      },

      // Reset store (on logout)
      reset: () => set({
        companies: [],
        selectedCompanyId: null,
        hasMultipleCompanies: false
      })
    }),
    {
      name: 'company-filter',
      // Only persist selectedCompanyId, companies come from API
      partialize: (state) => ({ selectedCompanyId: state.selectedCompanyId })
    }
  )
);

export default useCompanyStore;
